import { jsx } from 'react/jsx-runtime';
import styled from '@emotion/styled';
import { getStyle } from './utils.es.js';

const Wrapper = styled.div(({ height, commonStyle }) => `
  height: ${height}px;
  width: 100%;
  ${getStyle(commonStyle)}
`);
const Spacer = ({ height = 0, commonStyle, className }) => (jsx(Wrapper, { height: height, commonStyle: commonStyle, className: className }));
Spacer.displayName = 'Spacer';

export { Spacer as S };
